<script setup lang="tsx">
import type { Asset } from '@/models/api-generated'
import SubAssetInfo from './SubAssetInfo.vue'

const props = defineProps<{
	asset: Asset
	subAssetId: number
}>()
</script>

<template>
	<ul class="nav nav-tabs mb-3" id="assetTabs" role="tablist">
		<li class="nav-item" role="presentation">
			<button class="nav-link active" id="info-tab" data-bs-toggle="tab" data-bs-target="#info" type="button" role="tab">
				{{ $t('asset.info') }}
			</button>
		</li>
	</ul>

	<div class="tab-content" id="assetTabsContent">
		<div class="tab-pane fade show active" id="info" role="tabpanel" aria-labelledby="info-tab">
			<SubAssetInfo :asset="props.asset" :sub-asset-id="props.subAssetId" />
		</div>
	</div>
</template>
